export default __webpack_public_path__ + "static/media/cny_2024-bm.26ba2cf3.webp";